/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * List of the conditions defining asset scope of the notification rule
 */
export type PublicFilterNotificationRuleAssetScopeConditionDto = {
    /**
     * Type of the condition
     */
    type: PublicFilterNotificationRuleAssetScopeConditionDto.type;
};

export namespace PublicFilterNotificationRuleAssetScopeConditionDto {

    /**
     * Type of the condition
     */
    export enum type {
        SOURCE = 'SOURCE',
        TAG = 'TAG',
        ASSET = 'ASSET',
        DATA_PRODUCT = 'DATA_PRODUCT',
    }


}
